export const APP_BACKEND_URL = (() => {
  if (import.meta.env.VITE_APP_BACKEND_URL) {
    return import.meta.env.VITE_APP_BACKEND_URL;
  }
  // Fallback to current protocol + hostname
  return `${window.location.protocol}//${window.location.host}`;
})(); 